module.exports = __webpack_public_path__ + "static/media/down_arrow.a9e7811b.svg";